import React, { FC, Suspense } from 'react';
import { QueryClientProvider } from 'react-query';
import {
  BrowserRouter,
  generatePath,
  Navigate,
  Route,
  Routes,
  useParams,
} from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import Cart from 'components/Cart';
import Layout from 'components/Layout';
import ScrollToTop from 'components/ScrollToTop';
import Settings from 'components/Settings';
import Snackbar from 'components/Snackbar';
import { queryClient } from 'config/query';
import theme from 'config/theme';
import { useInitTelegramWebApp } from 'hooks/useInitTelegramWebApp';
import Checkout from 'pages/Checkout';
import Menu from 'pages/Menu';
import Week from 'pages/Week';
import { ROUTES } from 'utils/routes';

const App: FC = () => {
  useInitTelegramWebApp();
  const { userId } = useParams<{ userId: string }>();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Suspense fallback={null}>
          <Layout>
            <BrowserRouter>
              <Snackbar />
              <ScrollToTop />
              <Settings />
              <Cart>
                <Routes>
                  <Route path={ROUTES.WEEK} element={<Week />} />
                  <Route path={ROUTES.MENU_CURRENT_DAY} element={<Menu />} />
                  <Route path={ROUTES.CHECKOUT} element={<Checkout />} />
                  <Route
                    path={ROUTES.CHECKOUT_WITH_ORDER}
                    element={<Checkout />}
                  />
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={generatePath(ROUTES.WEEK, { userId: `${userId}` })}
                        replace
                      />
                    }
                  />
                </Routes>
              </Cart>
            </BrowserRouter>
          </Layout>
        </Suspense>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
